import React from "react";
import { inject, observer } from "mobx-react";
import withStyles from "react-jss";
import classNames from "classnames";
import Container from "reactstrap/lib/Container";
import { withRouter } from "react-router-dom";
import { graphql } from "@apollo/client/react/hoc";
import { TARIFF_TAGS_QUERY } from "Services/queries";
import { generateUrl } from "Services/withDefaultParams";
import Metrika from "Services/Metrika";
import { EVENT_CATEGORY_CLICK_BUTTON } from "Constants/metriks/GoogleCategorys";
import {
	EVENT_ACTION_CLICK_FLAT_BUTTON,
	EVENT_ACTION_CLICK_OFFICE_BUTTON,
} from "Constants/metriks/GoogleActions";
import routes from "Configs/routes";
import SeoBlockHOC from "HOC/SeoBlockHOC";
import { SeoBlockContainer } from "Containers/SeoBlock";
import AddressSearchContainer from "Containers/AddressSearchContainer";
import TopProviderContainer from "Containers/TopProviderContainer";
import { TagButton } from "ComponentsUI/Buttons";
import { ProvidersFilterContainer } from "Containers/Providers";
import { sendMetriks } from "Services/sendMetriks";

const styles = (theme) => ({
	buttonSet: {
		justifyContent: "flex-start",
		marginBottom: "50px",
	},
	block: {
		display: "block",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		buttonSet: {
			marginBottom: "20px",
		},
	},
});

class PageWithoutQuery extends React.Component {
	componentDidMount() {
		sendMetriks("LOAD_PAGE_RATES");
	}
	handleChoose(value) {
		if (value === "home") {
			Metrika.getInstance().google.sendEvent(
				EVENT_CATEGORY_CLICK_BUTTON,
				EVENT_ACTION_CLICK_FLAT_BUTTON
			);
		} else {
			Metrika.getInstance().google.sendEvent(
				EVENT_CATEGORY_CLICK_BUTTON,
				EVENT_ACTION_CLICK_OFFICE_BUTTON
			);
		}
	}

	onOperatorRatesmobile() {
		let regionUrl = this.props.ApplicationModel?.currentRegion?.url;
		return generateUrl(routes.RatesMobile.route, {
			regionUrl,
		});
	}

	render() {
		let {
			ApplicationModel: { text },
			classes,
			route,
		} = this.props;
		let tariffTags = this.props?.tariffsTags?.data;
		let tariffTagsFilterCount = [];
		if (tariffTags) {
			tariffTagsFilterCount = tariffTags.filter((elem) => elem.count);
		}
		let showNewViewSearch = this.props.ApplicationModel?.siteConfig?.settings?.show_new_view_search;
		return (
			<React.Fragment>
				<SeoBlockHOC route={route} placeText="AddressSearch">
					<AddressSearchContainer
						callback={(value) => this.handleChoose(value)}
						sendGAWhenFulled={true}
						showNewViewSearch={showNewViewSearch}
					/>
				</SeoBlockHOC>

				<Container>
					<SeoBlockContainer route={route} placeText="SeoBlock1" bgText={true} />
				</Container>

				{!!tariffTagsFilterCount.length && (
					<Container className={classNames(classes.buttonSet, classes.block)}>
						{tariffTags?.length && <TagButton active={true} ratesButton={true} />}
						{tariffTags?.length &&
							tariffTags
								.filter((x) => x.count)
								.map((tag) => <TagButton elem={tag} key={tag.url} ratesButton={true} />)}
						<TagButton anotherUrl={this.onOperatorRatesmobile()} elem={{ name: text.SIM_CARDS }} />
					</Container>
				)}
				<ProvidersFilterContainer />
				<Container>
					<SeoBlockContainer route={route} placeText="SeoBlock2" bgText={true} />
					<SeoBlockContainer route={route} placeText="SeoBlock3" bgText={true} />
					<SeoBlockHOC route={route} placeText="TopProvider">
						<TopProviderContainer backgroundNone={true} />
					</SeoBlockHOC>
					<SeoBlockContainer route={route} placeText="SeoBlock4" bgText={true} />
					<SeoBlockContainer route={route} placeText="SeoBlock5" bgText={true} />
				</Container>
			</React.Fragment>
		);
	}
}

export default withRouter(
	withStyles(styles)(
		inject("ApplicationModel")(
			observer(
				graphql(TARIFF_TAGS_QUERY, {
					skip: (ownProps) => {
						let currentRegion = ownProps?.ApplicationModel?.currentRegion?.url;
						return !currentRegion;
					},
					options: (props) => {
						let currentRegion = props?.ApplicationModel?.currentRegion?.url;
						return {
							variables: {
								filter: `region.url=${currentRegion}`,
							},
						};
					},
					props: ({ data }) => {
						if (data.tariffsTags) {
							return {
								tariffsTags: data.tariffsTags,
							};
						}
						return null;
					},
				})(PageWithoutQuery)
			)
		)
	)
);
